<template>
    <div class="mb-4" v-show="recommendations > 0">
        <card class="mb-0">
            <card-header>
                Recommendations by Facebook
            </card-header>

            <card-body class="pt-0" v-if="loading">
                <card-spinner style="height: 240px;"/>
            </card-body>

            <card-body class="pt-0 d-flex align-items-center" v-if="!loading && recommendations > 0">
                <img class="mr-1 iconClass" style="max-width:20px;" src="/img/recommendation.png">
                Recommended by {{ recommendations }} {{ personOrPeople }}
            </card-body>

            <card-body class="pt-0" v-if="!loading && recommendations === 0">
                <p class="lead text-black-50">No data to display</p>
            </card-body>
        </card>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        data() {
            return {
                loading: false,
                recommendations: 0
            }
        },

        created() {
            this.fetchRecommendations();
        },

        computed: {
            ...mapState(['filter']),

            personOrPeople() {
                if (this.recommendations <= 1) return 'person';
                return 'people';
            }
        },

        watch: {
            filter() {
                this.fetchRecommendations();
            }
        },

        methods: {
            fetchRecommendations() {
                this.loading = true;
                this.$http.get(this.$laroute.route('api.reviews.recommendation-facebook', {location: this.filter.location_id}))
                    .then(({ data }) => {
                        this.recommendations = data;
                        this.loading = false;
                    });
            }
        }
    }
</script>
